(() => {
  class DialogController {
    constructor(options = {}) {
      this.bodyClass = options.bodyClass || '';
      this.opener = options.opener || null;
      this.panel = options.panel || null;
      this.onOpen = options.onOpen || null;
      this.onClose = options.onClose || null;
    }

    isOpen() {
      return this.bodyClass && document.body.classList.contains(this.bodyClass);
    }

    open() {
      if (!this.bodyClass) return;

      document.body.classList.add(this.bodyClass);
      this.opener?.setAttribute('aria-expanded', 'true');
      this.panel?.setAttribute('aria-hidden', 'false');
      this.onOpen?.();
    }

    close({ returnFocus = false } = {}) {
      const wasOpen = this.isOpen();

      if (this.bodyClass) {
        document.body.classList.remove(this.bodyClass);
      }

      this.opener?.setAttribute('aria-expanded', 'false');
      this.panel?.setAttribute('aria-hidden', 'true');
      this.onClose?.({ wasOpen });

      if (returnFocus && wasOpen) {
        this.opener?.focus();
      }
    }

    toggle() {
      if (this.isOpen()) {
        this.close();
        return false;
      }

      this.open();
      return true;
    }
  }

  window.DialogController = DialogController;
})();
